import React       from 'react'
import PropTypes   from 'prop-types'
import { Alert }   from 'react-bootstrap'

import { NotFoundError, BadRequestError } from 'lib/errors'
import { ModalDialog                    } from 'alto-react-components/lib/components'

import EditUserTable from './edit_user_table'

export default class EditUserModal extends React.Component
  @contextTypes =
    auth: PropTypes.object

  constructor: (props, context) ->
    super(props, context)

    @state = { user: null, emailErrors: null }

  componentWillMount: ->
    @context.auth.repository.users.findBy(client: @props.client.id)
      .then (user) =>
        @setState(user: user)
      .catch NotFoundError, =>
        @setState(user: 'not-registered')

  updateEmail: (email) ->
    @context.auth.repository.users.partialUpdate(@state.user.id, email: email)
      .then                    (user) => @setState(user: user)
      .catch BadRequestError, (error) => @setState(emailErrors: error.data['email'])

  clearEmailErrors: ->
    @setState(emailErrors: null)

  sendActivationEmail: ->
    @context.auth.resendActivationEmail(@state.user.email)

  sendPasswordResetEmail: ->
    @context.auth.initPasswordReset(@state.user.email)

  toggleStaff: ->
    @context.auth.repository.users.partialUpdate(@state.user.id, isStaff: not @state.user.isStaff)
      .then (user) => @setState(user: user)

  deleteUser: ->
    @context.auth.repository.users.delete(@state.user.id)
      .then (user) => @setState(user: 'not-registered')

  render: ->
    <ModalDialog title="Editace webového účtu" closeButton={true} onHide={@props.onHide}>
      {@body()}
    </ModalDialog>

  body: ->
    if not @state.user
      <Alert>Načítám informace o webovém účtu</Alert>
    else if @state.user == 'not-registered'
      <Alert bsStyle='warning'>Klient není registrován</Alert>
    else
      <div>
        <EditUserTable user={@state.user}
                       emailErrors={@state.emailErrors}
                       updateEmail={@updateEmail.bind(@)}
                       clearEmailErrors={@clearEmailErrors.bind(@)}
                       sendActivationEmail={@sendActivationEmail.bind(@)}
                       sendPasswordResetEmail={@sendPasswordResetEmail.bind(@)}
                       toggleStaff={@toggleStaff.bind(@)}
                       deleteUser={@deleteUser.bind(@)} />
      </div>
